import { createSlice } from "@reduxjs/toolkit";

export const challengeSlice = createSlice({
  name: "setUpChallenge",
  initialState: {
    currentChallengeThemeCategory: null,
    currentChallengeTheme: null,
    currentChallenge: null,
    currentAssessment: null,
    lessonAssessment: null,
    selectedQuestions: [],
  },
  reducers: {
    onCurrentChallengeThemeCategory: (state, action) => {
      state.currentChallengeThemeCategory = action.payload;
    },
    onCurrentChallengeTheme: (state, action) => {
      state.currentChallengeTheme = action.payload;
    },
    onCurrentChallenge: (state, action) => {
      state.currentChallenge = action.payload;
    },
    setCurrentAssessment: (state, action) => {
      state.currentAssessment = action.payload;
    },
    setLessonAssessment: (state, action) => {
      state.lessonAssessment = action.payload;
    },
    setSelectedQuestions: (state, action) => {
      state.selectedQuestions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("SYNC/challengeStoreState", (state, action) => {
      return action.payload;
    });
  },
});
